import { defineMessages } from "react-intl";

export default defineMessages({
  creditCard: {
    id: "configureCreditCard.creditCard",
    defaultMessage: "Credit card",
  },
  tryLaterOrAnotherCard: {
    id: "configureCreditCard.tryLaterOrAnotherCard",
    defaultMessage:
      "Something went wrong. Please try later or select another payment method.",
  },
  goBack: {
    id: "configureCreditCard.goBack",
    defaultMessage: "Go back",
  },
});
